export default "__VITE_ASSET__CeQoJrpY__"